import * as actionTypes from "../actions/actionTypes";
import * as actionHandler from "../actions/layoutActions";

const initialState = {
  isSidebarOpen: true
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.TOGGLE_SIDEBAR:
      return {...state, isSidebarOpen: !state.isSidebarOpen}
    default:
      return state;
  }
};

export default reducer;
